var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "mb-15 2xl:mb-20 w-full",
    attrs: {
      "id": "form-intitule"
    }
  }, [_vm._v("\n    Identification du titulaire\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.prenom,
      "label": "Prénom"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.nom,
      "label": "Nom"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "col-span-full md:col-span-3",
    attrs: {
      "value": _vm.form.date_naissance,
      "label": "Date de naissance"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.genre,
      "label": "Genre"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.situation,
      "label": "Situation familliale"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.telephone,
      "label": "Téléphone"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.email,
      "label": "Email"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.website,
      "label": "Site internet personnel"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-6 md:row-span-2",
    attrs: {
      "value": _vm.form.adresse,
      "label": "Adresse complète",
      "grows-vertically": ""
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.hebergement,
      "label": "Hébergement"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.hebergement_precis,
      "label": "Autre hébergement"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "lg:col-start-1 md:col-span-3",
    attrs: {
      "value": _vm.form.niveau,
      "label": "Niveau de formation"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.niveau_precis,
      "label": "Autre niveau de formation"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.dernier_diplome,
      "label": "Dernier diplôme obtenu"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "lg:col-start-1 md:col-span-3",
    attrs: {
      "value": _vm.form.moyen_transport,
      "label": "Moyen de déplacement"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.moyen_transport_precis,
      "label": "Autre moyen de transport"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.permis,
      "label": "Permis de conduire"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.permis_precis,
      "label": "Autre permis"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "lg:col-start-1 md:col-span-3",
    attrs: {
      "value": _vm.form.type_revenus,
      "label": "Type de revenus"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.type_revenus_precis,
      "label": "Autre type de revenus"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.titre_sejour,
      "label": "Carte de séjour"
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "my-16 xxl:my-20 2xl:my-22",
    attrs: {
      "id": "form-infos-generales"
    }
  }, [_vm._v("\n    Informations générales\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
  }, [_c('multiple-field', {
    staticClass: "col-span-full md:col-span-6 place-self-start",
    attrs: {
      "value": _vm.form.travailleur_handicape,
      "label": "Etes-vous reconnu comme travailleur handicapé ?"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
  }, [_c('multiple-field', {
    staticClass: "col-span-full md:col-span-6",
    attrs: {
      "value": _vm.form.handicap,
      "label": "Type de handicap"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "col-span-full md:col-span-6",
    attrs: {
      "value": _vm.form.lourdeur_handicap,
      "label": "Reconnaissance lourdeur de handicap"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "col-span-full md:col-span-6",
    attrs: {
      "value": _vm.form.handicap_precis,
      "label": "Autre handicap"
    }
  })], 1), _vm._v(" "), _vm._l(_vm.form.type_reconnaissance.value, function (type, i_t) {
    return _c('div', {
      key: i_t,
      staticClass: "transition-all duration-300 flex items-center justify-center my-10"
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
    }, [_c('div', {
      staticClass: "col-span-full md:col-span-6 flex space-x-4"
    }, [_c('multiple-field', {
      staticClass: "mr-4 flex-shrink flex-initial",
      attrs: {
        "value": type.value.statut,
        "label": "Type de reconnaissance"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "hidden lg:flex col-start-auto col-span-6"
    }, [_c('multiple-field', {
      staticClass: "mr-4 flex-shrink flex-initial",
      attrs: {
        "value": type.value.cdaph,
        "label": "Numéro de dossier"
      }
    }), _vm._v(" "), _c('multiple-field', {
      attrs: {
        "value": type.value.cdaph_validite,
        "label": "Fin de validité"
      }
    })], 1), _vm._v(" "), _c('multiple-field', {
      staticClass: "lg:hidden col-span-full",
      attrs: {
        "value": type.value.cdaph,
        "label": "Numéro de dossier"
      }
    }), _vm._v(" "), _c('multiple-field', {
      staticClass: "lg:hidden col-span-full",
      attrs: {
        "value": type.value.cdaph_validite,
        "label": "Fin de validité"
      }
    })], 1)]);
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('multiple-field', {
    staticClass: "lg:col-start-1 col-span-full md:col-span-6",
    attrs: {
      "value": _vm.form.tutelle,
      "label": "Tutelle ou Curatelle"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.tutelle_precis,
      "label": "Précisez"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.tutelle_autre,
      "label": "Autre"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.tutelle_personne,
      "label": "Personne ou organisme"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('multiple-field', {
    staticClass: "lg:col-start-1 md:col-span-4",
    attrs: {
      "value": _vm.form.organisme_prescripteur,
      "label": "Organisme prescripteur"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.nom_referent,
      "label": "Nom du référent"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.tel_referent,
      "label": "Tél"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.organisme_social,
      "label": "Organisme référent"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.nom_referent_social,
      "label": "Nom du référent"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.tel_referent_social,
      "label": "Tél"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "lg:col-start-1 md:col-span-6 col-span-full",
    attrs: {
      "value": _vm.form.situation_emploi,
      "label": "Situation actuelle par rapport à l'emploi"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-6",
    attrs: {
      "value": _vm.form.situation_emploi_precis,
      "label": "Autre situation par rapport à l'emploi"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full flex items-end space-x-4"
  }, [_c('multiple-field', {
    staticClass: "w-6/12 md:w-3/12",
    attrs: {
      "value": _vm.form.pole_emploi,
      "label": "Etes-vous inscrit à Pôle Emploi ?"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "w-6/12",
    attrs: {
      "value": _vm.form.numero_pole_emploi,
      "label": "N° demandeur d'emploi"
    }
  })], 1), _vm._v(" "), _c('multiple-field', {
    staticClass: "lg:col-start-1 md:col-span-4 col-span-full",
    attrs: {
      "value": _vm.form.emploi,
      "label": "Emploi (ou projet professionnel)"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-4",
    attrs: {
      "value": _vm.form.structure,
      "label": "Nom de la structure actuelle"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "col-span-full md:col-span-4",
    attrs: {
      "value": _vm.form.date_structure,
      "label": "Date d'entrée dans la structure"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "lg:col-start-1",
    class: {
      'md:col-span-6': _vm.form.situation_anterieure.value === 'Autre',
      'md:col-span-3': _vm.form.situation_anterieure.value !== 'Autre'
    },
    attrs: {
      "value": _vm.form.situation_anterieure,
      "label": "Situation antérieure à l'entrée dans la structure"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-3",
    attrs: {
      "value": _vm.form.situation_anterieure_precis,
      "label": "Autre situation antérieure"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "md:col-span-6",
    attrs: {
      "value": _vm.form.referent,
      "label": "Référent (ou responsable hiérarchique)"
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "col-span-full md:col-span-6 lg:col-start-1 row-span-2",
    attrs: {
      "value": _vm.form.conditions1,
      "label": "Conditions de travail recherchées (préconisation)",
      "grows-vertically": ""
    }
  }), _vm._v(" "), _c('multiple-field', {
    staticClass: "col-span-full md:col-span-6 row-span-2",
    attrs: {
      "value": _vm.form.conditions2,
      "label": "Recommandations et propositions de mesures individuelles",
      "grows-vertically": ""
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm.form.proches.value.length > 0 ? _c('div', _vm._l(_vm.form.proches.value, function (proche, index) {
    return _c('div', {
      key: index,
      staticClass: "transition-all duration-300 flex flex-col space-y-10 mb-10"
    }, [_c('div', {
      staticClass: "grid grid-cols-10 gap-x-4 gap-y-10 w-full"
    }, [_c('div', {
      staticClass: "col-span-10 md:col-span-4 flex space-x-4"
    }, [_c('multiple-field', {
      attrs: {
        "value": proche.value.prenom_proche,
        "label": "Prénom"
      }
    })], 1), _vm._v(" "), _c('multiple-field', {
      staticClass: "md:col-span-3",
      attrs: {
        "value": proche.value.nom_proche,
        "label": "Nom"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-full md:col-span-3 grid grid-cols-2 gap-x-4"
    }, [_c('multiple-field', {
      staticClass: "md:col-span-full",
      attrs: {
        "value": proche.value.relation_proche,
        "label": "Relation"
      }
    }), _vm._v(" "), _c('multiple-field', {
      staticClass: "md:col-span-full",
      attrs: {
        "value": proche.value.relation_proche_precis,
        "label": "Autre relation",
        "name": "relation_proche_precis"
      }
    })], 1), _vm._v(" "), _c('multiple-field', {
      staticClass: "md:col-span-4 row-span-3",
      attrs: {
        "value": proche.value.adresse_proche,
        "label": "Adresse complète",
        "grows-vertically": ""
      }
    }), _vm._v(" "), _c('multiple-field', {
      staticClass: "md:col-span-3",
      attrs: {
        "value": proche.value.telephone_proche,
        "label": "Téléphone"
      }
    }), _vm._v(" "), _c('multiple-field', {
      staticClass: "md:col-span-3",
      attrs: {
        "value": proche.value.mail_proche,
        "label": "Mail"
      }
    })], 1), _vm._v(" "), index < _vm.form.proches.value.length - 1 ? _c('div', {
      staticClass: "w-full border-b border-gray-600"
    }) : _vm._e()]);
  }), 0) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h3', {
    staticClass: "my-16 xxl:my-20 2xl:my-22 w-full",
    attrs: {
      "id": "form-contacts"
    }
  }, [_vm._v("\n    Personnes à contacter "), _c('br'), _vm._v("en cas d'urgence\n  ")]);

}]

export { render, staticRenderFns }